import { Router } from '@reach/router'
import AboutPage from './pages/AboutPage'
import AnnouncementPage from './pages/AnnouncementPage'
import HelpPage from './pages/HelpPage'
import HomePage from './pages/HomePage'
import JobsDetailPage from './pages/JobsDetailPage'
import JobsPage from './pages/JobsPage'
import UserPage from './pages/UserPage'
import UserResumePage from './pages/UserResumePage'
import UserResumeEditPage from './pages/UserResumeEditPage'
import UserResumeCreatePage from './pages/UserResumeCreatePage'
import { BASE_PATH } from './constants/url'
import MyDeliverredPage from './pages/MyDeliveredPage'
import NotFoundPage from './pages/NotFoundPage'
import SurveyPage from './pages/SurveyPage'

const Routes: React.FC = () => {

  return(
    <Router id='router' basepath={BASE_PATH}>
      <HomePage path='/' />
      <JobsPage key='jobs' path='jobs' />
      <JobsDetailPage path='jobs/:id' />
      <AboutPage path='about' />
      <AnnouncementPage path='announcement' />
      <HelpPage path='help' />
      <UserPage path='user' />
      <UserResumeCreatePage path='user/resume/create' />
      <UserResumePage path='user/resume' />
      <UserResumeEditPage path='user/resume/edit' />
      <MyDeliverredPage path='user/delivered' />
      <SurveyPage path='user/survey' />
      <NotFoundPage default />
    </Router>
  )
}

export default Routes
